import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { Drawer, IconButton } from 'seagull';
import { Menu24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import HomeSidebar from "../../HomeSidebar/HomeSidebar";
import styles from "./SidebarMenu.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const getSidebarMenuTID = () => getTestIds();
export function SidebarMenu() {
  const {
    SidebarMenuTID
  } = useMemo(() => getSidebarMenuTID(), []);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      size: "small",
      testId: SidebarMenuTID.MenuButton(),
      onClick: () => setIsMenuOpen(true),
      children: /*#__PURE__*/_jsx(Menu24, {})
    }), /*#__PURE__*/_jsx(Drawer, {
      testId: SidebarMenuTID.Drawer(),
      anchor: "left",
      open: isMenuOpen,
      onClose: () => setIsMenuOpen(false),
      onCloseButtonClick: () => setIsMenuOpen(false),
      minWidth: 200,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.drawer,
        children: /*#__PURE__*/_jsx(HomeSidebar, {
          disableAutoNavigateGroup: true
        })
      })
    })]
  });
}